"use client";

import React, { PropsWithChildren } from "react";

import { BaseStoreProps, createAdvancedStore } from "@/stores/createAdvancedStore";

//

export interface SidebarStore extends BaseStoreProps {
  open: boolean;
  setOpen: (open: React.SetStateAction<boolean>) => void;
}

const sidebarStore = createAdvancedStore<SidebarStore>("Sidebar");
export const useSidebarStore = sidebarStore.useContext;

//

export const SidebarProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <sidebarStore.Provider
      value={(set, get) => ({
        open: false,
        setOpen: (updater) => {
          const prev = get().open;
          const open = typeof updater === "boolean" ? updater : updater(prev);
          if (prev === open) return;
          set({ open });
        },
      })}
    >
      {children}
    </sidebarStore.Provider>
  );
};
